export default{
      state:{
          selectedReport: null,
          selectedReportDetails: null,
  
          consultantId: '',
          empOrgId: '',
          
          AllQuestionCategoryList: [], // For Filter
          QuestionCategoryList: [],
          QuestionList: [],
  
          IsFilterApplied: false,
  
          searchFilter: {
              "QuestionType": "EmployeeSpecific",
              "QuestionCategory": [],
              "QuestionMode": [],
              "SearchText": ""
          }
      },
      mutations:{
          updateFDNSSelectedReport(state, p) {
              state.selectedReport = p
          },
  
          updateFDNSSelectedReportDetails(state, p) {
              state.selectedReportDetails = p
          },
  
          updateFDNSConsultantId(state, p) {
              state.consultantId = p
          },
  
          updateFDNSEmpOrgId(state, p) {
              state.empOrgId = p
          },
  
          updateFDNSQuestionCategoryList(state, p) {
              state.QuestionCategoryList = p
          },
  
          updateFDNSSearchFilterField(state, p) {
              Vue.set(state.searchFilter, p.field, p.value);
          },
  
          updateFDNSResetFDNSStore(state) {
              state.consultantId = ''
              state.empOrgId = ''
              state.selectedReport = null
              state.selectedReportDetails = null
              state.QuestionCategoryList = []
              state.AllQuestionCategoryList = []
              state.QuestionList = []
              state.IsFilterApplied = false
              state.searchFilter = {
                  "QuestionType": "EmployeeSpecific",
                  "QuestionCategory": [],
                  "QuestionMode": [],
                  "SearchText": ""
              }
          },
  
          updateFDNSResetSearchFilter(state) {
              state.searchFilter = {
                  "QuestionType": "EmployeeSpecific",
                  "QuestionCategory": [],
                  "QuestionMode": [],
                  "SearchText": ""
              }
  
              state.AllQuestionCategoryList = []
              state.QuestionCategoryList = []
  
              state.IsFilterApplied = false
          },
  
          updateFDNSQuestionList(state, arr) {
  
              let questionList = []
  
              let tempArr = []
  
              let tempCat = []
  
              if (arr.length > 0) {
                  arr = __.sortBy(arr, [function (o) {
                      return o.QuestionCategory.Name;
                  }])
  
                  let category = arr[0].QuestionCategory.Name
                  tempCat.push(category)
  
                  for (var i = 0; i < arr.length; i++) {
                      if (arr[i].QuestionCategory.Name == category) {
                          tempArr.push(arr[i])
                      } else {
                          questionList.push(tempArr)
                          tempArr = []
                          category = arr[i].QuestionCategory.Name
                          tempCat.push(category)
                          tempArr.push(arr[i])
                      }
                  }
  
                  if (tempArr.length > 0) {
                      questionList.push(tempArr)
                  }
  
                  if (tempCat[tempCat.length - 1] != category) {
                      tempCat.push(category)
                  }
              }
              // Move 'FAQ' to top
              let faqIndex = tempCat.findIndex(t => t == 'FAQ')
              if(faqIndex != -1) {
                  tempCat.splice(faqIndex, 1)
                  tempCat.splice(0, 0, 'FAQ')
  
                  let t = questionList[faqIndex]
  
                  questionList.splice(faqIndex, 1)
                  questionList.splice(0, 0, t)
              }
  
              state.QuestionCategoryList = tempCat
              state.QuestionList = questionList
  
              if(state.IsFilterApplied == false) {
                  state.AllQuestionCategoryList = tempCat
              }
          },
  
          updateFDNSIsFilterApplied(state, p) {
              state.IsFilterApplied = p
          }
      },
      getters:{
          getFDNSSelectedReport(state) {
              return state.selectedReport
          },
  
          getFDNSSelectedReportDetails(state) {
              return state.selectedReportDetails
          },
  
          getFDNSConsultantId(state) {
              return state.consultantId
          },
  
          getFDNSEmpOrgId(state) {
              return state.empOrgId
          },
          getFDNSAllQuestionCategoryList(state) { // For Filter
              return state.AllQuestionCategoryList
          },
          getFDNSQuestionCategoryList(state) {
              return state.QuestionCategoryList
          },
  
          getFDNSQuestionList(state) {
              return state.QuestionList
          },
  
          getFDNSSearchFilterField(state) {
              return field => {
                  return state.searchFilter[field];
              };
          },
          getFDNSSearchFilter(state) {
              return state.searchFilter;
          },
  
          getFDNSShowClearFilter(state) {
              return state.IsFilterApplied
          }
  
      }
  
  }


// WEBPACK FOOTER //
// ./src/store/modules/FDNS/index.js